import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as firebase from 'firebase/app';

import { ModalSize, SuiModalService, TemplateModalConfig, ModalTemplate } from 'ng2-semantic-ui';
import { SuiLocalizationService } from "ng2-semantic-ui";
import pt from "ng2-semantic-ui/locales/pt";

import { VqsAuthService } from '@vqs/vqs-app';
import { VqsAppService } from '@vqs/vqs-app';
import { VqsUploadService } from '@vqs/vqs-app';
import { Upload } from '@vqs/vqs-app';

import 'moment/locale/pt-br';
import * as moment_ from 'moment';
const moment = moment_;
moment.locale('pt-br');

export interface IContext { item: any; }
export interface Tickets { id: number; }
export interface TicketMessages { id: string; subject: string; }

export interface AttachmentsItem { url: string; unique_name: string; file_name: string; }
export interface AttachmentsItemId extends AttachmentsItem { id: string; }

@Component({
  selector: 'vqs-tickets-messages',
  templateUrl: './vqs-tickets-messages.component.html',
  styleUrls: ['./vqs-tickets-messages.component.css']
})
export class VqsTicketsMessagesComponent implements OnChanges, OnInit {

  @Input() config: any;
  @Input() ticket: any;
  @Input() requesters: any;
  @Input() attendants: any;
  @Input() folders: any;

  @ViewChild('modalTemplateTicket', { static: true })
  public modalTemplateTicket: ModalTemplate<IContext, string, string>

  @ViewChild('modalTemplateDelete', { static: true })
  public modalTemplateDelete: ModalTemplate<IContext, string, string>

  private ticketMessagesCollection: AngularFirestoreCollection<TicketMessages>;
  ticketMessages: Observable<TicketMessages[]>;

  private Attachments_Collection: AngularFirestoreCollection<AttachmentsItem>;
  Attachments_Items: Observable<AttachmentsItemId[]>;
  private attachments_Items_array = [];
  private attachments_Items_array2 = [];

  public currentUpload: Upload;
  public showReply = false;
  public showNote = false;
  public showForward = false;
  public sending: boolean;
  public reply: string;
  public replyId: string;
  public emailForward: string;
  public emailForwardCC: string;
  public emailForwardCCO: string;
  private replyAttachments: string;

  public dues_timestamp: any = [
    { id: 0, name: 'TICKETS.SLA.LESS' },
    { id: 24, name: 'TICKETS.SLA1' },
    { id: 48, name: 'TICKETS.SLA2' },
    { id: 72, name: 'TICKETS.SLA3' },
    { id: 96, name: 'TICKETS.SLA4' },
    { id: 120, name: 'TICKETS.SLA5' },
    { id: 144, name: 'TICKETS.SLA6' },
    { id: 168, name: 'TICKETS.SLA7' },
    { id: 192, name: 'TICKETS.SLA8' },
    { id: 216, name: 'TICKETS.SLA9' },
    { id: 240, name: 'TICKETS.SLA10' }
  ];

  public priorities: any = [
    { id: 1, name: 'TICKETS.PRIORITY.CRITICAL'  },
    { id: 2, name: 'TICKETS.PRIORITY.HIGH' },
    { id: 3, name: 'TICKETS.PRIORITY.MODERATE' },
    { id: 4, name: 'TICKETS.PRIORITY.LOW' }
  ];

  public signature: string;

  constructor(
    private modalService: SuiModalService,
    public localizationService: SuiLocalizationService,
    private readonly afs: AngularFirestore,
    private vqsAppService: VqsAppService,
    private vqsAuthService: VqsAuthService,
    private vqsUploadService: VqsUploadService,
    public sanitizer: DomSanitizer
  ) {
    localizationService.load("pt", pt);
    localizationService.setLanguage("pt");
  }

  ngOnInit() {
    this.vqsAuthService.dbS.collection("users").doc(this.vqsAuthService.userId).get()
    .then((doc) => {
      if (doc.exists) {
        this.signature = doc.data().signature ? doc.data().signature : '';
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getMessages();
  }

  getMessages() {
    this.ticketMessagesCollection = this.afs.collection<TicketMessages>('tickets/' + this.ticket.number.toString() + '/messages',
    ref => ref.orderBy('timestamp', 'desc'));
    this.ticketMessages = this.ticketMessagesCollection.valueChanges();
    this.showReply = false;
    this.showNote = false;
    this.showForward = false;
    this.reply = '';
    if (this.ticket.unread > 0) {
      this.vqsAuthService.dbS.collection('tickets').doc(this.ticket.number.toString()).update({
          unread: 0
      });
    }
  }


  changePriority() {
    const config = new TemplateModalConfig<IContext, string, string>(this.modalTemplateTicket);
    config.isClosable = true;
    config.transitionDuration = 200;
    config.size = ModalSize.Tiny;
    config.isInverted = false;
    config.context = {
      item: {
        action: 'change_priority',
        ticket: this.ticket,
        priority: this.ticket.priority
      }
    };
    this.modalService
      .open(config)
      .onDeny(result => {
        if((result) && (result['priority'])) {
          this.ticket.priority = result['priority'];
        }
      })
      .onApprove(result => {
        if(result['ticket']) {
        const id = result['ticket'].number.toString();
        this.vqsAuthService.dbS.collection('tickets').doc(id).update({
          priority: result['ticket'].priority
        }).then(() => {}, (error) => { console.log(error); });
      }
    });
  }


  changeRequester(number, requester) {
    let data = { requester: requester }
    if((this.config) && (this.config.requesterIsChildOf) &&
       (this.requesters) &&
       (this.vqsAppService.getObjByKey(this.requesters, 'id', requester)) &&
       (this.vqsAppService.getObjByKey(this.requesters, 'id', requester)[this.config.requesterIsChildOf])) {
      data[this.config.requesterIsChildOf] = this.vqsAppService.getObjByKey(this.requesters, 'id', requester)[this.config.requesterIsChildOf]
    }
    this.vqsAuthService.dbS.collection('tickets').doc(number.toString()).update(data);
  }


  changeAttendant(number, attendant) {
    this.vqsAuthService.dbS.collection('tickets').doc(number.toString()).update({
      attendant: attendant
    });
  }

  changeFolder(number, folder) {
    console.log(number, folder);
    this.vqsAuthService.dbS.collection('tickets').doc(number.toString()).update({
      folder: folder
    });
  }

  changeUnRead(tickets) {
    this.ticket.unread = 1;
    this.vqsAuthService.dbS.collection('tickets').doc(tickets.number.toString()).update({
      unread: 1
    });
  }

  closeTicket(ticket) {
    const id = ticket.number.toString();
    this.vqsAuthService.dbS.collection('tickets').doc(id).update({
      status: 'C'
    })
  }

  reOpenTicket(ticket) {
    const config = new TemplateModalConfig<IContext, string, string>(this.modalTemplateTicket);
    config.isClosable = true;
    config.transitionDuration = 200;
    config.size = ModalSize.Tiny;
    config.isInverted = false;
    config.context = {
      item: {
        action: 'open',
        ticket: ticket,
      }
    };
    this.modalService
      .open(config)
      .onDeny(result => { })
      .onApprove(result => {
        if(result['ticket']) {
          const id = result['ticket'].number.toString();
          this.vqsAuthService.dbS.collection('tickets').doc(id).update({
            status: 'O'
          }).then(() => {
            this.ticket = [];
          }, (error) => {
            console.log(error);
          });
        }
      });
  }


  spamTicket(ticket) {
    const config = new TemplateModalConfig<IContext, string, string>(this.modalTemplateTicket);
    config.isClosable = true;
    config.transitionDuration = 200;
    config.size = ModalSize.Tiny;
    config.isInverted = false;
    config.context = {
      item: {
        action: 'spam',
        ticket: ticket,
      }
    };
    this.modalService
      .open(config)
      .onDeny(result => { })
      .onApprove(result => {
        if(result['ticket']) {
          const email = result['ticket'].creator_email;
          const id = result['ticket'].number.toString();
          this.vqsAuthService.dbS.collection('tickets_spams').doc(email).set({ active: true }).then(() => {
            this.vqsAuthService.dbS.collection('tickets').doc(id).delete().then(() => {
              this.ticket = [];
            }, (error) => {
              console.log(error);
            });
          }, (error) => {
            console.log(error);
          });
        }
      });
  }


  deleteTicket(ticket) {
    const config = new TemplateModalConfig<IContext, string, string>(this.modalTemplateDelete);
    config.isClosable = true;
    config.transitionDuration = 200;
    config.size = ModalSize.Tiny;
    config.isInverted = false;
    config.context = {
      item: {
        header: 'TICKETS.TITLE.MODAL.DELETE',
        service: 'ticket',
        ticket: ticket,
      }
    };
    this.modalService
      .open(config)
      .onDeny(result => { })
      .onApprove(result => {
        if(result['ticket']) {
          const id = result['ticket'].number.toString();
          const basePath = 'tickets/' + id + '/attachments';

          this.vqsAuthService.dbS.collection('tickets').doc(id).collection('messages').get().then(snapshotMessages => {
            snapshotMessages.forEach(doc => {
              this.vqsAuthService.dbS.collection('tickets').doc(id).collection('messages').doc(doc.id).delete();
            });
          });

          this.vqsAuthService.dbS.collection("tickets").doc(id).collection("attachments").get().then((snapshotAttachments) => {
            snapshotAttachments.forEach((doc) => {
                this.vqsUploadService.deleteUpload(basePath, doc.id, doc.data().unique_name);
            });
          })

          this.vqsAuthService.dbS.collection('tickets').doc(id).delete().then(() => {
              this.ticket = [];
          }, (error) => {
              console.log(error);
          });
        }
      });
  }


  forwardTicket(ticket) {
    this.emailForward = '';
    this.emailForwardCC = '';
    this.emailForwardCCO = '';
    this.showReply = false;
    this.showNote = false;
    this.showForward = true;
    this.attachments_Items_array = [];
    this.attachments_Items_array2 = [];
    this.replyId = moment().unix().toString();
    this.replyAttachments = '';

    this.vqsAuthService.dbS
    .collection('tickets')
    .doc(this.ticket.number.toString())
    .collection('messages')
    .orderBy('timestamp', 'desc')
    .get()
    .then((snap) => {
      this.reply = '';
      snap.forEach(element => {
        const files = element.data().files;
        for (let i=0; i<files.length; i++) {
          const file = files[i];
          if (!this.replyAttachments) { this.replyAttachments = '<ul>'; }
          this.replyAttachments += '<li><a style="cursor: pointer;" href="' + file.path + '" target="_blank">' + file.filename + '</a></li>'
        }
        if ((!element.data().note) && (!this.reply)) {
          // this.reply += + '<br>' + element.data().html + '<hr>'
          this.reply += (this.signature ? ('<br>' + this.signature) : '') + '<hr>'
          + moment.unix(element.data().timestamp).format('DD/MM/YYYY HH:mm') + '<br>'
          + element.data().html + '<br><br>';
        }
      });
      if (this.replyAttachments) {
        this.replyAttachments += '</ul><br>Anexos:' + this.replyAttachments;
      }
      this.Attachments_Collection = this.afs.collection<AttachmentsItem>('tickets/' + this.replyId+ '/attachments');
      this.Attachments_Items = this.Attachments_Collection.snapshotChanges().pipe(
        map(actions => {
          this.attachments_Items_array = [];
          this.attachments_Items_array2 = [];
          return actions.map(a => {
            const data = a.payload.doc.data() as AttachmentsItem;
            const id = a.payload.doc.id;
            this.attachments_Items_array.push({ path: data.url, filename: data.file_name });
            this.attachments_Items_array2.push({ id: id, data: data });
            return { id, ...data };
          });
        }
      ));
    })
  }

  getSafeUrl(html) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(html);
  }

  replyTicket(ticket) {
    this.reply = this.signature ? ('<br>' + this.signature) : '';
    this.showReply = true;
    this.showNote = false;
    this.showForward = false;
    this.attachments_Items_array = [];
    this.attachments_Items_array2 = [];
    this.replyId = moment().unix().toString();
    this.replyAttachments = '';

    this.vqsAuthService.dbS
    .collection('tickets')
    .doc(this.ticket.number.toString())
    .collection('messages')
    .orderBy('timestamp', 'desc')
    .get()
    .then((snap) => {
      this.reply = ''; //'<br><br>' + (this.signature ? ('<br>' + this.signature) : '') + '<br>';
      snap.forEach(element => {
        const files = element.data().files;
        for (let i=0; i<files.length; i++) {
          const file = files[i];
          if (!this.replyAttachments) { this.replyAttachments = '<ul>'; }
          this.replyAttachments += '<li><a style="cursor: pointer;" href="' + file.path + '" target="_blank">' + file.filename + '</a></li>'
        }
        if ((!element.data().note) && (!this.reply)) {
          // this.reply += + '<br>' + element.data().html + '<hr>'
          this.reply += (this.signature ? ('<br>' + this.signature) : '') + '<hr>' + moment.unix(element.data().timestamp).format('DD/MM/YYYY HH:mm') + '<br>' + element.data().html + '<br><br>';
        }
      });
      if (this.replyAttachments) {
        this.replyAttachments += '</ul><br>Anexos:' + this.replyAttachments;
      }

      this.Attachments_Collection = this.afs.collection<AttachmentsItem>('tickets/' + this.replyId+ '/attachments');
      this.Attachments_Items = this.Attachments_Collection.snapshotChanges().pipe(
        map(actions => {
          this.attachments_Items_array = [];
          this.attachments_Items_array2 = [];
          return actions.map(a => {
            const data = a.payload.doc.data() as AttachmentsItem;
            const id = a.payload.doc.id;
            this.attachments_Items_array.push({ path: data.url, filename: data.file_name });
            this.attachments_Items_array2.push({ id: id, data: data });
            return { id, ...data };
          });
        }
      ));
    })
  }

  notesTicket(ticket) {
    this.reply = '';
    this.showReply = false;
    this.showNote = true;
    this.showForward = false;
  }

  sendReply(close) {
    let attendantMail;
    const attendant = this.ticket.attendant ? this.ticket.attendant : null;
    if (attendant) {
      this.vqsAuthService.dbS.collection('users').doc(attendant)
      .get().then(docUser => {
        if (docUser.exists) {
          const alias_tickets = docUser.data().alias_tickets;
          const alias_tickets2 = docUser.data().alias_tickets2;

          if (!alias_tickets && !alias_tickets2) {
            this.sendReply2(close, null);
          }
          else if (alias_tickets && !alias_tickets2) {
            this.sendReply2(close, alias_tickets);
          }
          else if (!alias_tickets && alias_tickets2) {
            this.sendReply2(close, alias_tickets2);
          } else {
            if (this.ticket.to === alias_tickets) {
              this.sendReply2(close, alias_tickets);
            } else if (this.ticket.to === alias_tickets2) {
              this.sendReply2(close, alias_tickets2);
            }
          }
        }
      })
    }
  }

  sendReply2(close, alias_tickets) {
    const id = this.replyId;
    const subject = '[#' + this.ticket.number + '] ' + this.ticket.subject;
    const message = {
      //answered: true,
      timestamp: moment().unix(),
      subject: subject,
      to: this.ticket.creator_email,
      from: [{
        name: this.vqsAuthService.user.displayName,
        email: this.vqsAuthService.user.email,
        photo: this.vqsAuthService.user.photoURL ? this.vqsAuthService.user.photoURL : null
      }],
      html: this.reply,
      hasAnexo: (this.attachments_Items_array.length > 0) ? true : false,
      files: this.attachments_Items_array
    }

    this.vqsAuthService.dbS.collection('tickets').doc(this.ticket.number.toString()).collection('messages').add(message).then((result) => {
      const sendEmail = firebase.functions().httpsCallable('sendEmail');
      const data = {
        name: '',
        from: alias_tickets ? alias_tickets : null,
        email: this.ticket.creator_email,
        subject: subject,
        html: this.reply + (this.replyAttachments ? this.replyAttachments : ''),
        cc: this.ticket.email_cc ? this.ticket.email_cc : null,
        cco: this.ticket.email_cco ? this.ticket.email_cco : null,
        attachments: this.attachments_Items_array
      };
      const self = this;
      sendEmail(data).then(function () {
        self.replyAttachments = '';
        let data2;
        if (close) {
          if (self.ticket.step === 1) {
            data2 = {
              step: 2,
              status: 'C',
              close_timestamp: moment().unix().toString()
            }
          }
          else {
            data2 = {
              status: 'C',
              close_timestamp: moment().unix().toString()
            };
          }
        }
        else {
          if (self.ticket.step === 1) {
            data2 = {
              step: 2
            }
          }
        }

        if (data2) {
          self.vqsAuthService.dbS.collection('tickets').doc(self.ticket.number.toString()).update(data2).then(function () {
            self.attachments_Items_array = [];
            self.attachments_Items_array2 = [];
            self.ticket = [];
            self.showReply = false;
            self.showNote = false;
            self.showForward = false;
            self.reply = '';
          }).catch(function (error) {
            console.log(error);
          });
        }
        else {
          self.attachments_Items_array = [];
          self.attachments_Items_array2 = [];
          self.showReply = false;
          self.showNote = false;
          self.showForward = false;
          self.reply = '';
        }
      }).catch(function (error) {
          console.log(error);
      });
    }, (error) => {
        console.log(error);
    });
  }


  sendForward() {
    const id = this.replyId;
    const subject = '[#' + this.ticket.number + '] ' + this.ticket.subject;
    const message = {
      //answered: true,
      timestamp: moment().unix(),
      subject: subject,
      to: this.emailForward,
      from: [{
        name: this.vqsAuthService.user.displayName,
        email: this.vqsAuthService.user.email,
        photo: this.vqsAuthService.user.photoURL ? this.vqsAuthService.user.photoURL : null
      }],
      html: this.reply,
      hasAnexo: (this.attachments_Items_array.length > 0) ? true : false,
      files: this.attachments_Items_array
    }
    this.vqsAuthService.dbS.collection('tickets').doc(this.ticket.number.toString()).collection('messages').add(message).then((result) => {
      const sendEmail = firebase.functions().httpsCallable('sendEmail');
      const data = {
        email: this.emailForward,
        subject: subject,
        html: this.reply + (this.replyAttachments ? this.replyAttachments : ''),
        cc: this.emailForwardCC ? this.emailForwardCC : null,
        cco: this.emailForwardCCO ? this.emailForwardCCO : null,
        attachments: this.attachments_Items_array
      };
      const self = this;
      sendEmail(data).then(function () {
        self.replyAttachments = '';
        let data2;
        if (self.ticket.step === 1) {
          data2 = {
            step: 2
          }
        }

        if (data2) {
          self.vqsAuthService.dbS.collection('tickets').doc(self.ticket.number.toString()).update(data2).then(function () {
            self.attachments_Items_array = [];
            self.attachments_Items_array2 = [];
            self.ticket = [];
            self.showReply = false;
            self.showNote = false;
            self.showForward = false;
            self.reply = '';
          }).catch(function (error) {
            console.log(error);
          });
        }
        else {
          self.attachments_Items_array = [];
          self.attachments_Items_array2 = [];
          self.showReply = false;
          self.showNote = false;
          self.showForward = false;
          self.reply = '';
        }
      }).catch(function (error) {
          console.log(error);
      });
    }, (error) => {
        console.log(error);
    });
  }


  hideAll() {
    this.showReply = false;
    this.showNote = false;
    this.showForward = false;
    this.reply = '';
  }


  saveNote(note) {
    const id = moment().unix().toString();
    const message = {
      note: true,
      timestamp: id,
      from: [{
        name: this.vqsAuthService.user.displayName,
        email: this.vqsAuthService.user.email,
        photo: this.vqsAuthService.user.photoURL ? this.vqsAuthService.user.photoURL : null
      }],
      html: note
    }
    this.vqsAuthService.dbS.collection('tickets').doc(this.ticket.number.toString()).collection('messages').add(message).then((result) => {
      this.showReply = false;
      this.showNote = false;
      this.showForward = false;
      this.reply = '';
    });
  }


  onUploadError(args: any) {
    console.log('onUploadError:', args);
  }


  onUploadSuccess(args: any, id) {
    this.currentUpload = new Upload(args[0]);
    const filename = (args[0].name).toLowerCase();
    const basePath = 'tickets/' + id + '/attachments';
    this.vqsUploadService.pushUpload(this.currentUpload, basePath, filename, null, null, null, { status: 'T' });
  }


  deleteFile(file, id) {
    const basePath = 'tickets/' + id + '/attachments/';
    this.vqsUploadService.deleteUpload(basePath, file.id, file.unique_name);
  }


}
